// Shape matches admin_service's real GET /adminDashboard/customers response: CustomerDto[] directly,
// not wrapped in an envelope - AdminContentProvider stores this array verbatim as `customers`.
export const getCustomersResp = [
  {
    id: "aaaaaaaa-1111-4aaa-8aaa-aaaaaaaaaaaa",
    name: "Signol",
    customerCode: "SG",
    industry: "aviation",
  },
  {
    id: "bbbbbbbb-2222-4bbb-8bbb-bbbbbbbbbbbb",
    name: "Virgin Atlantic",
    customerCode: "VS",
    industry: "aviation",
  },
  {
    id: "cccccccc-3333-4ccc-8ccc-cccccccccccc",
    name: "British Airways",
    customerCode: "BA",
    industry: "aviation",
  },
  {
    id: "dddddddd-4444-4ddd-8ddd-dddddddddddd",
    name: "Demo Shipping Co",
    customerCode: "DS",
    industry: "shipping",
  },
];
